import { useParams } from 'react-router-dom';

import { useHeader } from 'context';
import { mapQuery } from 'utils/query';
import { useGetQuery } from 'store/api/company';
import { Details, CompanyBusinessForm } from 'components';

export const Edit = () => {
  const { id } = useParams();
  const { data, ...props } = useGetQuery(id!, { skip: !id });

  useHeader({ showBackButton: true, pageName: 'Edit Company' });

  return (
    <Details {...mapQuery(props)}>
      <CompanyBusinessForm data={data} hasNavigate />
    </Details>
  );
};
